// extracted by mini-css-extract-plugin
module.exports = {"UsernameStatus":"UsernameInput_UsernameStatus__2zr60","error":"UsernameInput_error__gjfYe"};